/* ==========================================================================
   Page Transition / Intro Loader — Original Renegade
   Settings: Theme settings > Page Transition / Intro Loader
   Failsafes: hard timeout, Escape key, click-to-dismiss, bfcache cleanup.
   ========================================================================== */
(function () {
  'use strict';

  var html = document.documentElement;
  var overlay = document.getElementById('page-transition');

  function hideNow() {
    html.classList.remove('pt-active');
    html.classList.remove('pt-exit');
    if (overlay) {
      overlay.classList.remove('is-leaving');
      overlay.setAttribute('aria-hidden', 'true');
    }
  }

  /* Back/forward cache restore (e.g. user hits Back after an exit
     transition): kill any stuck overlay immediately. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) hideNow();
  });

  if (!overlay) return;

  var d = overlay.dataset;
  var duration = parseInt(d.duration, 10) || 600;
  var delay = parseInt(d.delay, 10) || 0;
  var designMode = d.designMode === 'true';
  var reducedMotion =
    d.reducedMotion === 'true' &&
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var dismissed = false;

  function leave() {
    if (dismissed) return;
    dismissed = true;
    overlay.classList.add('is-leaving');
    overlay.setAttribute('aria-hidden', 'true');
    window.setTimeout(function () {
      hideNow();
    }, 500);
  }

  /* ------------------------------------------------------------------
     Intro loader (only if the boot script activated it)
     ------------------------------------------------------------------ */
  if (html.classList.contains('pt-active')) {
    overlay.setAttribute('aria-hidden', 'false');

    var enterBtn = overlay.querySelector('[data-pt-enter]');
    var useEnter = d.enter === 'true' && enterBtn;

    var start = function () {
      if (useEnter) {
        window.setTimeout(function () {
          if (dismissed) return;
          enterBtn.hidden = false;
          try { enterBtn.focus({ preventScroll: true }); } catch (e) { enterBtn.focus(); }
        }, Math.max(delay, duration));
        /* In the editor, never require a click — auto-dismiss so the
           preview keeps working while settings are changed. */
        if (designMode) {
          window.setTimeout(leave, Math.max(delay, duration) + 1500);
        }
      } else {
        window.setTimeout(leave, delay + duration);
      }
    };

    if (document.readyState === 'complete') {
      start();
    } else {
      var started = false;
      var kick = function () {
        if (started) return;
        started = true;
        start();
      };
      window.addEventListener('load', kick);
      /* Don't wait forever on slow third-party resources */
      window.setTimeout(kick, 3500);
    }

    if (enterBtn) {
      enterBtn.addEventListener('click', leave);
    }

    /* Safety valves: Escape always dismisses; clicking the overlay
       backdrop dismisses too. */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') leave();
    });
    overlay.addEventListener('click', function (e) {
      if (!useEnter || e.target === overlay) leave();
    });

    /* Hard failsafe: the overlay can never outlive this, no matter what. */
    window.setTimeout(leave, delay + duration + 6000);
  }

  /* ------------------------------------------------------------------
     Internal link exit transitions
     ------------------------------------------------------------------ */
  if (d.links !== 'true' || designMode || reducedMotion) return;

  var exitMs = Math.min(duration, 400);
  var navigating = false;

  document.addEventListener('click', function (e) {
    if (navigating) return;
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a) return;

    /* Opt-outs and non-navigations */
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download')) return;
    if (a.getAttribute('role') === 'button') return;
    if (a.hasAttribute('data-no-transition') || a.closest('[data-no-transition]')) return;

    var raw = a.getAttribute('href') || '';
    if (
      raw === '' ||
      raw.charAt(0) === '#' ||
      raw.indexOf('mailto:') === 0 ||
      raw.indexOf('tel:') === 0 ||
      raw.indexOf('javascript:') === 0
    ) return;

    var url;
    try {
      url = new URL(a.href, window.location.href);
    } catch (err) {
      return;
    }

    /* Same-origin only */
    if (url.origin !== window.location.origin) return;

    /* Never touch checkout or cart permalinks */
    if (url.pathname.indexOf('/checkout') === 0) return;
    if (/^\/cart\/\d/.test(url.pathname)) return;
    if (url.pathname.indexOf('/cart/c/') === 0) return;
    if (url.pathname.indexOf('/password') === 0) return;

    /* Same-page hash jump */
    if (
      url.pathname === window.location.pathname &&
      url.search === window.location.search &&
      url.hash
    ) return;

    e.preventDefault();
    navigating = true;

    html.classList.add('pt-exit');
    overlay.setAttribute('aria-hidden', 'false');

    window.setTimeout(function () {
      window.location.href = url.href;
    }, exitMs);

    /* If navigation is somehow blocked, recover after 3s */
    window.setTimeout(function () {
      navigating = false;
      hideNow();
    }, exitMs + 3000);
  });
})();
